import { Stack } from "@mui/material";

const FlexVerticalAlignCenter = ({ children, ...props }) => (
  <Stack direction="column" justifyContent="center" height="100%" {...props}>
    {children}
  </Stack>
);

export default FlexVerticalAlignCenter;
